module.exports = __webpack_public_path__ + "static/media/multiple_crawlers.706c44d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/multiple_crawlers.svg
// module id = 406
// module chunks = 0